import React from "react";
import "./HowItWorks.css";

const HowItWorks = ({ backgroundImage }) => {
  const hasBackground = !!backgroundImage;

  const steps = [
    {
      number: "01",
      title: "Rules Are Drawn",
      description: (
        <>
          We draw two rules, a <em>Form</em> rule and a <em>Wildcard</em> that
          you have to include in your film.
        </>
      ),
    },
    {
      number: "02",
      title: "Get to Work",
      description: (
        <>
          <em>You get about one month</em> to write, crew up, shoot, and edit
          your film.
        </>
      ),
    },
    {
      number: "03",
      title: "Films Are Submitted",
      description: (
        <>
          You submit before the deadline. First-timers and veterans go through
          the same process.
        </>
      ),
    },
    {
      number: "04",
      title: "Screen & Celebrate",
      description: (
        <>
          We screen the films for a <em>live audience</em>. Directors present
          their films, the audience asks questions, then we do it all over
          again.
        </>
      ),
    },
  ];

  return (
    <section className={`hiw-section ${hasBackground ? "hiw-with-bg" : ""}`}>
      {hasBackground && (
        <>
          <div
            className="hiw-bg"
            style={{ backgroundImage: `url(${backgroundImage})` }}
          />
          <div className="hiw-bg-overlay" />
        </>
      )}
      <div className="hiw-content">
        <h2 className="hiw-heading">How It Works</h2>

        <div className="hiw-timeline">
          {steps.map((step) => (
            <div className="hiw-step" key={step.number}>
              <div className="hiw-dot" />
              <div className="hiw-number">{step.number}</div>
              <div className="hiw-title">{step.title}</div>
              <div className="hiw-body">{step.description}</div>
            </div>
          ))}
        </div>

        <div className="hiw-loop-badge">
          <div className="hiw-loop-icon">
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <circle cx="12" cy="12" r="10" />
              <circle cx="12" cy="12" r="3" />
              <circle cx="12" cy="5.5" r="1.2" />
              <circle cx="17.5" cy="9" r="1.2" />
              <circle cx="17.5" cy="15" r="1.2" />
              <circle cx="12" cy="18.5" r="1.2" />
              <circle cx="6.5" cy="15" r="1.2" />
              <circle cx="6.5" cy="9" r="1.2" />
            </svg>
          </div>
          <span className="hiw-loop-text">Repeat Every Challenge</span>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
